




















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import {
  createComponent,
  inject,
  onMounted,
  onUnmounted,
  computed,
  ref
} from "@vue/composition-api";
import DisplayUIKey from "@/components/display-ui-key";
import CompanyRecruitmentKey from "@/components/company-recruitment-key";
import CompanyKey from "@/components/company-key";
import FeatureSearch from "./FeatureSearch.vue";
import SkillSearch from "./SkillSearch.vue";
import JobSearch from "./JobSearch.vue";
import FormHeader from "../../molecules/FormHeader.vue";
import Snackbar from "../../molecules/Snackbar.vue";
import JobDetailApplication from "./JobDetailApplication.vue";
import RecruitmentErrorDialog from "../../../views/Recruitment/RecruitmentErrorDialog.vue";
import DialogUpdateJobDraft from "./DialogUpdateJobDraft.vue";
import router from "../../../router";
import customValidator from "@/lib/customValidator.ts";
export default createComponent({
  setup() {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const companyRecruitment = inject(CompanyRecruitmentKey);
    if (!companyRecruitment) {
      throw new Error(`${CompanyRecruitmentKey} is not provided`);
    }

    const company = inject(CompanyKey);
    if (!company) {
      throw new Error(`${CompanyKey} is not provided`);
    }

    const jobDetailForm = ref(null);
    const inputDetailSalary = (e: string) => {
      e = e.replace(/,/g, "");
      companyRecruitment.inputDetailSalary(e);
    };
    const inputDetailFee = (e: string) => {
      e = e.replace(/,/g, "");
      companyRecruitment.inputDetailFee(e);
    };

    const inputDetailDateFrom = (e: string) => {
      companyRecruitment.inputDetailDateFrom(e);
    };

    const inputDetailDateTo = (e: string) => {
      companyRecruitment.inputDetailDateTo(e);
    };

    const inputPostDateFrom = (e: string) => {
      companyRecruitment.inputPostDateFrom(e);
    };

    const inputPostDateTo = (e: string) => {
      companyRecruitment.inputPostDateTo(e);
    };

    const common_id = window.location.pathname.split("/")[3];
    const recruitment = window.location.pathname.split("/")[5];
    const startDate = window.location.pathname.split("/")[7];

    const jobInforDetail = companyRecruitment.jobSearchInformationDetail;
    const getWorkingTime = companyRecruitment.getWorkingTime;
    const getPostalCode = companyRecruitment.getPostalCode;
    const prefectures = computed(() => companyRecruitment.prefectureName);
    const municipalities = computed(() => companyRecruitment.municipalitiName);
    const getListCity = companyRecruitment.getDetailListCity;
    const prefecture_code =
      companyRecruitment.jobInforDetail.workLocation.prefecture_code;
    const getListPrefecture = companyRecruitment.getListPrefecture;
    const getApplicationInfo = companyRecruitment.getApplicationInfo;
    const renderJobTypeSelect = companyRecruitment.renderJobTypeSelect;
    const renderJobSkillSelect = companyRecruitment.renderJobSkillSelect;
    const renderFeatureSelect = companyRecruitment.renderFeatureSelect;

    //get job categori to display
    const getJobSkill = companyRecruitment.getJobSkill;
    const getJobFeature = companyRecruitment.getJobFeature;
    const getJobType = companyRecruitment.getJobType;
    const jobInfor = computed(() => companyRecruitment.jobInforDetail) as any;
    const searchPostalCode = async (postal1: any, postal2: any) => {
      const address = (await companyRecruitment.searchPostalCode(
        postal1,
        postal2
      )) as any;
      if (address.data) {
        await displayui.openDialogRecruitmentError();
      } else {
        await companyRecruitment.getCityByPostalCode();
      }
    };
    const disableControl = computed(() => {
      var card_info_flg = company.companyInformation.companyInforList.card_info_flg
      var ht_flg = company.companyInformation.companyInforList.ht_flg
      return (card_info_flg !== 1 && ht_flg !== 1)
    })
    const clearList = companyRecruitment.clearJobSelected;
    onMounted(async () => {
      clearList();
      var newStartDate = "";
      if (startDate) {
        newStartDate = startDate.replace(/_/g, "/");
        companyRecruitment.inputDetailAppicationDate(newStartDate);
      }

      /*
      注意1 
        renderが終わったあとに各getXXを呼ばないとバグるときがある模様
      注意2 
      JobTypeだけはrenderJobTypeSelectとgetJobTypeが相互依存している・・・
      複雑なことをやっていて解析する時間がもったいないので
      一旦render→get→renderの順で呼び出すことで強引に解決
      時間のあるときに修正すること
      */
      renderJobTypeSelect().then(() =>
        getJobType(common_id).then(() => renderJobTypeSelect())
      );
      renderJobSkillSelect().then(() => getJobSkill(common_id)),
        renderFeatureSelect().then(() => getJobFeature(common_id));

      await company.getCompanyInfor();
      await jobInforDetail(common_id, recruitment, newStartDate),
        await getPostalCode(common_id),
        await getWorkingTime(common_id),
        await getListPrefecture();
    });

    const deleteJob = companyRecruitment.deleteJob;
    const deleteImage = (index: any) => {
      let a = document.getElementById("image" + index) as any;
      a.value = "";
      companyRecruitment.deleteImage(index);
    };
    const updateJobInfor = async (draftFlg: any) => {
      //@ts-ignore
      if (!jobDetailForm.value.validate()) {
        return;
      }
      const updateJob = (await companyRecruitment.updateJobInfor(
        draftFlg
      )) as any;
      if (updateJob) {
        await companyRecruitment.changeJobDetailFeeFlag();
        await displayui.openDialogRecruitmentError();
        companyRecruitment.clearJobFormData();
      } else {
        companyRecruitment.clearJobFormData();
        router.push("/company_offer", () => {});
      }
    };

    const addJobDraftDuplicate = async (draftFlg: any) => {
      const capacity = companyRecruitment.jobInforDetail.jobInformation
        .capacity as any;
      const dateFrom = companyRecruitment.jobInforDetail.jobInformation
        .work_start_date as any;
      const dateTo = companyRecruitment.jobInforDetail.jobInformation
        .work_end_date as any;
      const date1 = new Date(dateFrom) as any;
      const date2 = new Date(dateTo) as any;
      const diffTime = Math.abs(date2 - date1);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;

      const updateJob = (await companyRecruitment.addJobDuplicate(
        draftFlg
      )) as any;
      if (updateJob) {
        await companyRecruitment.changeJobDetailFeeFlag();
        await displayui.openDialogRecruitmentError();
      } else if (capacity * diffDays >= 10) {
        displayui.openDialogUpdateJobDraft();
        companyRecruitment.clearJobFormData();
      } else {
        companyRecruitment.clearJobFormData();
        router.push("/company_offer", () => {});
      }
    };

    const addJobDuplicate = async (draftFlg: any) => {
      //@ts-ignore
      if (!jobDetailForm.value.validate()) {
        return;
      }
      const duplicateJob = (await companyRecruitment.addJobDuplicate(
        draftFlg
      )) as any;
      if (duplicateJob) {
        await companyRecruitment.changeJobDetailFeeFlag();
        await displayui.openDialogRecruitmentError();
      } else {
        companyRecruitment.clearJobFormData();
        router.push("/company_offer", () => {});
      }
    };

    const totalPayment = computed(
      () => companyRecruitment.jobDetailTotalPayment
    );
    const selectTransCost = companyRecruitment.selectTransCost;
    const viewJobImage = companyRecruitment.viewJobImage;
    const detailFilePicked1 = companyRecruitment.detailFilePicked1;
    const detailFilePicked2 = companyRecruitment.detailFilePicked2;
    const detailFilePicked3 = companyRecruitment.detailFilePicked3;
    const jobDuplicate = computed(() => companyRecruitment.jobDuplicate);
    const openJobSearchDialog = computed(() => displayui.openJobSearchDialog);
    const openDialogFeatureSearch = computed(
      () => displayui.openFeatureSearchDialog
    );
    const openDialogSkillSearch = computed(
      () => displayui.openSkillSearchDialog
    );

    //display job category
    const skills = computed(() =>
      companyRecruitment.skillSearch.selected.map(
        (item: { small_name: string }) => item.small_name
      )
    );
    const featuresSearch = computed(() =>
      companyRecruitment.featureSearch.selected.map(
        (item: { small_name: string }) => item.small_name
      )
    );
    const jobSearch = computed(() =>
      companyRecruitment.jobSearch.selected.map(
        (item: { job_small_name: string }) => item.job_small_name
      )
    );

    const companyInfor = computed(
      () => company.companyInformation.companyInforList
    ) as any;
    const formatNumber = (number: string) => displayui.formatNumber(number);
    const formatDate = (date: string) => displayui.formatDate(date);
    onUnmounted(() => {
      companyRecruitment.clearDetailJobParams();
      displayui.closeDialogUpdateJobDraft();
    });

    return {
      inputDetailSalary,
      inputDetailFee,
      jobInfor,
      jobDuplicate,
      openJobSearchDialog,
      openDialogFeatureSearch,
      openDialogSkillSearch,
      detailFilePicked1,
      detailFilePicked2,
      detailFilePicked3,
      viewJobImage,
      selectTransCost,
      deleteJob,
      deleteImage,
      getListCity,
      prefectures,
      municipalities,
      addJobDuplicate,
      updateJobInfor,
      searchPostalCode,
      skills,
      featuresSearch,
      jobSearch,
      totalPayment,
      companyInfor,
      formatNumber,
      addJobDraftDuplicate,
      formatDate,
      inputDetailDateFrom,
      inputDetailDateTo,
      inputPostDateFrom,
      inputPostDateTo,
      customValidator,
      jobDetailForm,
      disableControl
    };
  },

  components: {
    FeatureSearch,
    SkillSearch,
    JobSearch,
    FormHeader,
    JobDetailApplication,
    RecruitmentErrorDialog,
    DialogUpdateJobDraft
  }
});
